<template>
  <div class="Container">
    <ContentTop :activeKey="2" @searchData="searchData"/>
    <BlackList :tableData="tableData"/>
    <!-- <p class="text">
      *Special conditions may apply. Please visit delegation service website for details</p> -->
  </div>
</template>

<script>
  import ContentTop from '@/components/commons/ContentTop';
  import BlackList from '@/components/table/BlackList';
  import { mapState } from 'vuex';

  export default {
    name: 'Home',
    components: {
      ContentTop,
      BlackList,
    },
    created() {
      this.$store.dispatch('black/getBlackList');
    },
    computed: {
      ...mapState('black', {
        tableData: 'list',
        allList: 'allList',
      }),
    },
    methods: {
      searchData(kd) {
        const allData = this.allList;
        const payload = {};
        if (!kd) {
          payload.list = allData;
        } else {
          const searchList = [];
          const len = allData.length;
          for (let i = 0; i < len; i += 1) {
            const item = allData[i];
            if (item.name.toUpperCase()
              .indexOf(kd.toUpperCase()) > -1 || item.address.toUpperCase()
              .indexOf(kd.toUpperCase()) > -1) {
              searchList.push(item);
            }
          }
          payload.list = searchList;
        }
        this.$store.commit('black/save', payload);
      },
    },
  };
</script>
